import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { AlarisDialogComponent } from '@campaign-portal/components-library';
import { CircleWarningComponent } from '@helpers/components/circle-warning/circle-warning.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-confirm-close-dialog',
	templateUrl: './dialog-close.component.html',
	styleUrl: './dialog-close.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [AlarisDialogComponent, CircleWarningComponent, TranslateModule]
})
export class ConfirmCloseDialogComponent {
	constructor(
		@Inject(DIALOG_DATA) public data: { message: string },
		private readonly dialogRef: DialogRef<boolean>
	) {}

	confirm(): void {
		this.dialogRef.close(true);
	}

	close(): void {
		this.dialogRef.close(false);
	}
}